module.exports = __webpack_public_path__ + "img/cardImg04.34ed99af.jpg";